// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"ad7b2f23","33":"b0542208","282":"2e24ea4b","407":"53051051","424":"a862b2c0","453":"a2e54734"}[chunkId] + ".chunk.js";
};